  import React, { useState, useEffect } from "react";
  import { Link, useLocation } from "react-router-dom";
  import { useWebsiteSettings } from "../contexts/WebsiteSettingsContext";

  export default function StickyNavbar() {
    const location = useLocation();
    const { settings } = useWebsiteSettings();
    const [show, setShow] = useState(false);

    // Show navbar on scroll
    useEffect(() => {
      const handleScroll = () => {
        setShow(window.scrollY > 100); // show after 100px scroll
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const isActive = (path) => {
      if (path === "/") {
        return location.pathname === "/";
      }
      return location.pathname.startsWith(path);
    };

    return (
      <nav
        className={`fixed top-0 left-0 w-full bg-white py-3 px-6 shadow-md z-50 transition-transform duration-500 ${
          show ? "translate-y-0 hidden md:block" : "-translate-y-full"
        }`}
      >
        <div className="flex justify-between items-center max-w-6xl mx-auto">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src={settings?.logo || "/images/home/logo.png"}
              alt="Logo"
              className="h-16 w-16 object-contain"
            />
          </Link>

          {/* Navigation Links */}
          <ul className="hidden md:flex space-x-6 items-center text-xl font-semibold">
            <li>
              <Link 
                to="/" 
                className={`hover:text-red-600 ${isActive("/") ? "text-red-600" : ""}`}
              >
                Home
              </Link>
            </li>
            <li>
              <Link 
                to="/services" 
                className={`hover:text-red-600 ${isActive("/services") ? "text-red-600" : ""}`}
              >
                Services
              </Link>
            </li>
            <li>
              <Link 
                to="/projects" 
                className={`hover:text-red-600 ${isActive("/achievement") ? "text-red-600" : ""}`}
              >
                Projects
              </Link>
            </li>
            <li>
              <Link 
                to="/about" 
                className={`hover:text-red-600 ${isActive("/about") ? "text-red-600" : ""}`}
              >
                About
              </Link>
            </li>
            <li>
              <Link 
                to="/contact" 
                className={`hover:text-red-600 ${isActive("/contact") ? "text-red-600" : ""}`}
              >
                Contact
              </Link>
            </li>
            {/* <li className="ms-3">
              <a
                className="flex items-center "
                href="mailto:admin@sm6corp.com"
              >
                <i
                  className="bi bi-envelope-fill me-1"></i>
                <span className="hover:text-red-900">admin@sm6corp.com</span>
              </a>
            </li>
            <li className="ms-3 flex space-x-5">
              <a href="/" className="fs-5 hover:text-red-900">
                <i className="bi bi-facebook text-2xl"></i>
              </a>
              <a href="/" className="fs-5 hover:text-red-900">
                <i className="bi bi-instagram text-2xl"></i>
              </a>
              <a href="/" className="fs-5 hover:text-red-900">
                <i className="bi bi-linkedin text-2xl"></i>
              </a>
            </li> */}
          </ul>
        </div>
      </nav>
    );
  }
